import { render } from "./WebAuthnRegister.vue?vue&type=template&id=31558cae&scoped=true"
import script from "./WebAuthnRegister.vue?vue&type=script&lang=js"
export * from "./WebAuthnRegister.vue?vue&type=script&lang=js"

import "./WebAuthnRegister.vue?vue&type=style&index=0&id=31558cae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3894535366/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31558cae"]])

export default __exports__